"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IfhirR4 = exports.fhirR3 = exports.fhirR4 = void 0;
var fhirR4 = require("./FHIR-R4/classes/models-r4");
exports.fhirR4 = fhirR4;
var IfhirR4 = require("./FHIR-R4/interfaces/IModel");
exports.IfhirR4 = IfhirR4;
var fhirR3 = require("./FHIR-R3");
exports.fhirR3 = fhirR3;
